import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { PageHeader, EmptyState } from "../components/Shared";
import { api, fmtDate } from "../lib/api";
import { Stars } from "./PublicReview";

function Summary({ data }) {
  return (
    <div className="mb-6 grid gap-4 sm:grid-cols-3">
      <div className="rounded-xl bg-[#0b2c6b] p-5 text-white">
        <p className="text-xs uppercase tracking-widest text-blue-200">Note moyenne</p>
        <p className="mt-1 flex items-center gap-2 font-display text-3xl font-bold" data-testid="reviews-average">{data.average ?? "—"}<Star className="h-6 w-6 fill-amber-400 text-amber-400" /></p>
        <p className="text-xs text-blue-200" data-testid="reviews-count">{data.count} avis</p>
      </div>
      <div className="rounded-xl border border-slate-200 bg-white p-5">
        <p className="text-xs uppercase tracking-widest text-slate-500">Demandes envoyées</p>
        <p className="mt-1 font-display text-3xl font-bold text-slate-900" data-testid="reviews-requests-sent">{data.requests_sent}</p>
        <p className="text-xs text-slate-500">{data.pending} en attente d'envoi</p>
      </div>
      <div className="space-y-1 rounded-xl border border-slate-200 bg-white p-5" data-testid="reviews-distribution">
        {[5, 4, 3, 2, 1].map((n) => {
          const c = data.distribution[String(n)];
          return (
            <div key={n} className="flex items-center gap-2 text-xs text-slate-600">
              <span className="w-3">{n}</span><Star className="h-3 w-3 fill-amber-400 text-amber-400" />
              <div className="h-2 flex-1 rounded-full bg-slate-100"><div className="h-2 rounded-full bg-amber-400" style={{ width: `${data.count ? (c / data.count) * 100 : 0}%` }} /></div>
              <span className="w-5 text-right">{c}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function Reviews() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/reviews").then((r) => setData(r.data));
  }, []);
  if (!data) return null;
  return (
    <div className="fade-up">
      <PageHeader overline="Satisfaction" title="Avis clients" subtitle="Demandés automatiquement par e-mail 2 h après la fin de chaque chantier, avec un rappel le lendemain à 10h." />
      <Summary data={data} />
      {data.reviews.length === 0 ? <EmptyState text="Aucun avis pour le moment" testid="reviews-empty" /> : (
        <div className="grid gap-4 md:grid-cols-2">
          {data.reviews.map((r) => (
            <div key={r.id} className="rounded-xl border border-slate-200 bg-white p-5" data-testid={`review-card-${r.id}`}>
              <div className="flex items-center justify-between"><Stars value={r.rating} size="h-4 w-4" testid={`review-${r.id}-star`} /><span className="text-xs text-slate-400">{fmtDate(r.created_at)}</span></div>
              <p className="mt-3 text-sm text-slate-700">{r.comment || <span className="italic text-slate-400">Sans commentaire</span>}</p>
              <p className="mt-3 text-xs font-semibold text-slate-500">{r.client_name} · Déménagement du {fmtDate(r.move_date)}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
